import React from 'react';

interface ArticleShareProps {
  darkMode: boolean;
  title: string;
  location: string;
}

const ArticleShare = ({ darkMode, title, location }: ArticleShareProps) => {
  // console.log(location, "location")
  function callReactNativeFunction(value: string) {
    // console.log(value, "value location")
    if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(`callReactNativeFunction:${value}`);
    } else {
      alert("This feature is only available in the mobile app.");
    }
  }

  return (
    <div className={`border-t border-b py-4 my-6 ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
      <div className="flex items-center justify-between" onClick={() => callReactNativeFunction(location)}>
        <span className={`${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Share this article:</span>
        <div className="flex space-x-2">
          <div className="d-hide justify-content-between mb-1 mt-1 app-share">
            <img              
              src="/images/icons/react-share.webp"
              width="50"
              height="50"
              alt="Share article"
              style={{ cursor: 'pointer' }}
              role="button"
              aria-label="Share article"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleShare;
